/* Katalog sayfalarının (Slot, Canlı Casino) slider'ı için görünürlük kararı.
 *
 * Slider'ın kendisi bütün şemalarda ortaktır (components/PageSlider.jsx) ve
 * banner'lar panelde konumla ayrışır (lib/sliderPlacement.js). Buradaki tek
 * ek, **Vega şemasına özel** panel seçimidir: o kabukta katalog sayfası
 * slider'ı sayfa sayfa açılıp kapatılabilir (Ayarlar → Tasarım). Ayrım
 * bilinçlidir — seçim yalnızca Vega yayındayken anlamlıdır ve panel de
 * kutucukları yalnızca o şemada çizer.
 *
 * İkinci kutu, o konumda banner yokken **ana sayfa banner'larına düşmeyi**
 * açar ve varsayılan olarak **kapalıdır**: katalog banner'ı ana sayfadakinden
 * bilinçli olarak farklı seçilebildiği için sızma kendiliğinden olmaz,
 * yönetici bilerek açar. Kutu kapalıyken davranış bütün şemalardaki gibidir —
 * o konumda banner yoksa slider hiç çizilmez.
 */

import { DEFAULT_PLACEMENT, slidersAt } from './sliderPlacement';

export const VEGA_THEME_ID = 'vega';

// Konum → ayar alanları. Listede olmayan konum (ör. ana sayfa) seçime tabi
// değildir ve her zaman kendi banner'larıyla çizilir.
export const VEGA_PAGE_SLIDERS = {
  slot: {
    enabled: 'vega_slot_slider_enabled',
    useMain: 'vega_slot_slider_use_main',
  },
  'live-casino': {
    enabled: 'vega_live_casino_slider_enabled',
    useMain: 'vega_live_casino_slider_use_main',
  },
};

/**
 * Bu konumdaki slider çizilsin mi?
 *
 * Vega dışındaki şemalarda karar yoktur (her zaman çizilir); Vega'da alan
 * yalnızca açık bir `false` ile kapanır — kolon eklenmeden önceki
 * kurulumlarda değer hiç yazılmamıştır ve görünüm değişmemelidir.
 */
export const pageSliderEnabled = (settings, themeId, placement) => {
  if (themeId !== VEGA_THEME_ID) return true;
  const keys = VEGA_PAGE_SLIDERS[placement];
  if (!keys) return true;
  return (settings || {})[keys.enabled] !== false;
};

/** Bu konumda banner yokken ana sayfa banner'larına düşülsün mü? */
export const pageSliderUsesMain = (settings, themeId, placement) => {
  if (themeId !== VEGA_THEME_ID) return false;
  const keys = VEGA_PAGE_SLIDERS[placement];
  if (!keys) return false;
  // Yalnızca açık bir `true` ile açılır: alanı hiç yazılmamış kurulumda
  // katalog sayfası ana sayfanın banner'ını göstermeye başlamamalıdır.
  return (settings || {})[keys.useMain] === true;
};

/**
 * Konumun banner'ları.
 *
 * Konumun kendi banner'ı varsa ana sayfaya hiç bakılmaz — yedek seçeneği bir
 * karışım değil, boş sayfanın alternatifidir.
 */
export const pageSliderSlides = (slides, placement, useMain = false) => {
  const own = slidersAt(slides, placement);
  if (own.length || !useMain) return own;
  return slidersAt(slides, DEFAULT_PLACEMENT);
};

export default pageSliderEnabled;
